import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950 mb-3">
            精选品类
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            从家居到时尚，从生活到特惠，久久精品为您精心划分每一份品质之选
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${encodeURIComponent(cat.slug)}`}
              className="group relative overflow-hidden rounded-lg aspect-[3/4] cursor-pointer"
              data-product-shop
            >
              <img
                src={cat.imageUrl}
                alt={cat.name}
                title={`${cat.name} | 久久精品品质甄选`}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-600"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                <h3 className="text-lg md:text-xl font-heading font-semibold text-white mb-1">
                  {cat.name}
                </h3>
                <p className="text-xs md:text-sm text-white/80 line-clamp-2 mb-2">{cat.description}</p>
                <span className="text-xs text-white/70">{cat.productCount} 件好物</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}